import { DigitalLibraryService, getDigitalServiceColor, ResolvedPaletteColor } from "@libry-content/common";
import { useCommonData } from "../layout/CommonDataProvider";

export const useDigitalServiceColor = (
  service?: Pick<DigitalLibraryService, "_id">
): ResolvedPaletteColor | undefined => {
  const { site } = useCommonData();

  return getDigitalServiceColor({ service, site });
};
